window.Products.Clothing.PremiumZipperHoodie = function() {
};
window.Products.Clothing.PremiumZipperHoodie.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.PremiumZipperHoodie.dpi = 150;
window.Products.Clothing.PremiumZipperHoodie.has_3d = true;
window.Products.Clothing.PremiumZipperHoodie.id = 112;
window.Products.Clothing.PremiumZipperHoodie.slug = 'premium-zipper-hoodie';
window.Products.Clothing.PremiumZipperHoodie.syncColors = true;
window.Products.Clothing.PremiumZipperHoodie.texturesLoaded = 0;
window.Products.Clothing.PremiumZipperHoodie.texturesLoading = false;
window.Products.Clothing.PremiumZipperHoodie.use_glb = true;

window.Products.Clothing.PremiumZipperHoodie.prototype.outsideObject = 0;
window.Products.Clothing.PremiumZipperHoodie.prototype.detailsObject = 1;
window.Products.Clothing.PremiumZipperHoodie.prototype.position = 0;

window.Products.Clothing.PremiumZipperHoodie.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.PremiumZipperHoodie.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"navy_blue": 0x2d2d3b,
		"dark_heather": 0x505052,
		"sport_grey": 0xc6c3c9,
		"maroon": 0x7c2235,
	};

	return new THREE.Color(colors[_name]);
};